import { Router } from '@angular/router';

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isClientUuid(value: string | null | undefined): boolean {
  return UUID_RE.test((value ?? '').trim());
}

export function clientDetailPath(row: { uuid?: string | null }): string[] | null {
  const uuid = (row?.uuid ?? '').trim();
  return isClientUuid(uuid) ? ['/manage-client', uuid] : null;
}

export function clientEditPath(row: { uuid?: string | null }): string[] | null {
  const detail = clientDetailPath(row);
  return detail ? [...detail, 'edit'] : null;
}

export function goToClientDetail(
  router: Router,
  row: { uuid?: string | null },
  onError?: (message: string) => void,
): void {
  const path = clientDetailPath(row);
  if (path) {
    void router.navigate(path);
    return;
  }
  onError?.('This client is missing a profile link. Refresh the list and try again.');
}
